const governancePrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.CAMPAIGN_GOVERNANCE)

interface IFetchApprovalRequestsQuery {
	page?: number
	perPage?: number
}

interface IFetchAuditLogQuery {
	page?: number
	perPage?: number
	/** Endpoint zwraca jeden typ naraz; brak filtra = `campaign` (domyślnie po stronie BE). */
	subjectType?: 'campaign' | 'promotion'
	subjectId?: number
	/** Daty w formacie akceptowanym przez BE (np. `YYYY-MM-DD`). */
	startDate?: string
	endDate?: string
}

export const apiCampaignWorkflow = {
	fetchApprovalRequests: async (
		query: IFetchApprovalRequestsQuery = {},
	): Promise<IApiResponseModel<ICampaignApprovalRequestDto[]>> => {
		const { page, perPage } = query
		const pagination = buildPagination(page, perPage)
		const { data, meta } = await apiCommon<ICampaignApprovalRequestDto[]>(`${governancePrefix}/approval-requests`, {
			method: 'GET',
			...createQuery(pagination),
		})
		return { data, meta }
	},

	approveCampaign: async (id: number): Promise<void> => {
		await apiCommon(`${governancePrefix}/approval-requests/campaign/${id}/approve`, { method: 'POST' })
	},

	rejectCampaign: async (id: number, rejectionReason: string): Promise<void> => {
		await apiCommon(`${governancePrefix}/approval-requests/campaign/${id}/reject`, {
			method: 'POST',
			body: { rejection_reason: rejectionReason } satisfies ICampaignRejectPayload,
		})
	},

	fetchGlobalAuditLog: async (query: IFetchAuditLogQuery = {}): Promise<IApiResponseModel<IAuditLogEntryModel[]>> => {
		const { page = 1, perPage = 25, subjectType, subjectId, startDate, endDate } = query
		// BE czyta `filter[subject_type|subject_id|start_date|end_date]` + proste `page`/`per_page`.
		const { data } = await apiCommon<IActivityLogResponseDto>(`${governancePrefix}/audit-log`, {
			method: 'GET',
			...createQuery(
				null,
				{ subject_type: subjectType, subject_id: subjectId, start_date: startDate, end_date: endDate },
				undefined,
				{ page, per_page: perPage },
			),
		})
		return ActivityLogResponse(data)
	},
}
